// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrwl-r-side-btn[data-v-15a4f880] {\n    transform-origin: bottom right;\n    transform: rotate(90deg);\n    top: 3rem;\n    right: 1rem;\n    z-index: 1;\n}\n.scrwl-r-side-btn[data-v-15a4f880]:hover {\n    right: 2em;\n}\n", ""]);
// Exports
module.exports = exports;
